interface DefaultCardProps {
  content: any;
}

function extractBlock(content: any, blockType: string): any {
  return content?.latest_version?.blocks?.find((b: any) => b.block_type === blockType);
}

const DefaultCard: React.FC<DefaultCardProps> = ({ content }) => {
  const hook = extractBlock(content, "hook");
  const cta = extractBlock(content, "cta");

  return (
    <>
      {hook && <div className="hook">{hook.narration || hook.caption}</div>}
      {cta && <div className="preview">{cta.narration || cta.caption}</div>}
    </>
  );
};

export default DefaultCard;
